import * as React from 'react';
import * as queryString from 'query-string';
import { Props } from 'react';
import { connect, Dispatch } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { AppState } from '../../reducers';

import { setUserIdAction, setChannelIdAction, setUserLangAction } from '../../actions/user';
import i18next from 'i18next';
import { HomeButtonView } from '../Buttons/HomeButton/HomeButtonView';

interface RouteProps extends RouteComponentProps<{}> {
    history: any;
}

interface HomeVtbMedicalContainerProps extends Props<HomeVtbMedicalContainer> {
    channelId: string;
    lang: string;
}

interface HomeVtbMedicalContainerDispatch extends Props<HomeVtbMedicalContainer> {
    setUserId: (userId: string) => any;
    setChannelId: (channelId: string) => any;
    setLang: (lang: string) => any;
}

function mapProps(state: AppState, props: HomeVtbMedicalContainerProps): HomeVtbMedicalContainerProps {
    return {
        channelId: state.userState.channelId,
        lang: state.userState.lang
    };
}

function mapDispatch(dispatch: Dispatch<any>) {
    return {
        setUserId: (userId: string) => dispatch(setUserIdAction(userId)),
        setChannelId: (channelId: string) => dispatch(setChannelIdAction(channelId)),
        setLang: (lang: string) => dispatch(setUserLangAction(lang))
    };
}

type AllProps = HomeVtbMedicalContainerProps & HomeVtbMedicalContainerDispatch & RouteProps;

class HomeVtbMedicalContainer extends React.Component<AllProps> {
    async componentDidMount() {
        const { history, setUserId, setChannelId, setLang, lang } = this.props;
        if (history.location.search) {
            const params = queryString.parse(history.location.search);
            const userId = params.user_id;
            const channelId = params.channel_id;
            const language = params.lang;
            if (!lang) {
                setLang(language || 'ru');
            }
            if (language && language !== lang && i18next.languages.some(it => it === lang)) {
                setLang(language);
                await i18next.changeLanguage(language);
            }

            if (userId) {
                setUserId(userId);
            }
            if (channelId) {
                setChannelId(channelId);
            }
        }
    }

    render() {
        document.title = i18next.t('travels');
        const { history } = this.props;
        return (
            <div className='container'>
                <HomeButtonView
                    clickHome={() => history.push(`/services?user_id=${encodeURIComponent(localStorage.KON_USER_ID)}&channel_id=${localStorage.KON_CHANNEL_ID}&lang=${localStorage.KON_LANG}&tariff_id=${localStorage.KON_TARIFF_ID}`)}
                />
                <div className='taxi-container' style={{paddingBottom: 110, marginTop: 12}}>
                    <div>
                        <img src={require('../../assets/online-doctor-header-image.png')} />
                    </div>
                    <div className='taxi-container__title'>
                        {i18next.t('vtb_medical')}
                    </div>
                    {i18next.t('mastercard_gives_you')}
                    <div className='taxi-container__title'>
                        {i18next.t('at_you_service')}:
                    </div>
                    - Личный врач-куратор (безлимитно)
                    <br/>
                    - Служба поддержки 24/7 (безлимитно)
                    <br/>
                    - Дежурные врачи (терапевт и педиатр) (безлимитно)
                    <br/>
                    - Узкопрофильные врачи (безлимитно) на выбор из 62 специальностей
                    <br/>
                    - Очные приемы врачей по специализациям по назначению врача (2 очных приема)
                    <div className='taxi-container__title'>
                        {i18next.t('as_well_as')}:
                    </div>
                    -  Чекап «Скрининг здоровья» - комплексное ежегодное лабораторное обследование для мужчин и женщин (30 показателей, 1 раз за год)
                    <br/>
                    - ПЦР качественный или количественный (гинекологический или урогенитальный мазок, мазок из зева или носа, 2 раза в год)
                    <br/>
                    - Инструментальные исследования (кроме КТ и МРТ, по назначению врача, 2 раза за год)
                    <br/>
                    - Выдача медицинской документации, листок нетрудоспособности, рецепты, кроме льготных категорий (2 раз в год)
                    <div className='taxi-container__title'>
                        {i18next.t('and_dental_services')}:
                    </div>
                    - Консультация врача стоматолога-терапевта (2 консультации)
                    <br/>
                    - Лечение неосложненного кариеса 2 зуба при степени разрушения не более 30% (без повреждения пульпы)
                    <div className='taxi-container__title'>
                        {i18next.t('how_to_use')}?
                    </div>
                    Перейдите на сайт и введите промокод, полученный в банке
                </div>
                <div className='taxi-container__button'>
                    <button onClick={() => window.open('http://vtb.onlinedoctor.ru/', '_blank')}>
                        {i18next.t('go_to_website')}
                    </button>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(mapProps, mapDispatch)(HomeVtbMedicalContainer));



// WEBPACK FOOTER //
// ./src/components/VtbMedical/HomeVtbMedicalContainer.tsx